// @systeme: scoping-org
// ============================================================================
// Casquettes d'une personne — l'organisation ACTIVE par défaut
// ============================================================================
// Une personne a UN compte et N appartenances (`user_memberships`), chacune
// avec ses rôles ; le jeton n'en scope qu'une à la fois (P8). Laquelle au
// login, et laquelle « maison » au retour d'immersion ? Jusqu'au lot D des
// retours bêta (2026-10-27), un drapeau `is_default` posé à la première
// création du compte — et déplacé sur Cecodev_Inter par la bascule alumni —
// décidait, à l'inverse de ce que FX attend.
//
// Règle FX (2026-10-27) : « lorsque Cecodev, c'est celle-ci la prioritaire
// (Cecodev_Inter ou Intra sont annexes) ; lorsque non Cecodev, si Intra +
// Cecodev_Inter, c'est l'Intra la prioritaire ; sinon ils seront juste dans une
// seule orga ». Un raffinement, posé ici et à confirmer : une org où la
// personne est PILOTE prime sur une org où elle ne l'est pas — sans quoi le
// pilote d'une org cliente devenu alumni (participant de Cecodev) atterrirait
// chez Cecodev sans son menu de pilotage, et sans sélecteur pour en sortir
// (le bloc « Mes organisations » n'apparaît qu'à qui pilote deux orgs).
//
// Pour un animateur ou un participant, le choix est invisible : ses espaces
// personnels réunissent toutes ses casquettes et basculent d'org tout seuls
// (`useCasquetteImplicite`). Le drapeau `is_default` n'est plus qu'un dernier
// départage (dette N270).
// ============================================================================
/** Ordre de priorité des types d'organisation (plus petit = prioritaire). */
export const PRIORITE_TYPE_ORG = {
    CECODEV: 0,
    CLIENT_INTRA: 1,
    INTER: 2,
    OF: 3,
    STANDARDS: 9,
};
/** PILOTE ou SUPER_ADMIN : la personne administre cette organisation. */
export function estRolePilote(roles) {
    return roles.includes("PILOTE") || roles.includes("SUPER_ADMIN");
}
function rangType(type) {
    return type ? (PRIORITE_TYPE_ORG[type] ?? 8) : 8;
}
/**
 * Compare deux casquettes : négatif si `a` passe avant `b`.
 * 1. org pilotée avant org non pilotée ; 2. Cecodev > Intra > Cecodev_Inter ;
 * 3. ancien drapeau par défaut ; 4. nom puis id (ordre stable, jamais l'ordre
 * de lecture en base).
 */
export function comparerCasquettes(a, b) {
    const pa = estRolePilote(a.roles) ? 0 : 1;
    const pb = estRolePilote(b.roles) ? 0 : 1;
    if (pa !== pb)
        return pa - pb;
    const ta = rangType(a.organisationType);
    const tb = rangType(b.organisationType);
    if (ta !== tb)
        return ta - tb;
    const da = a.isDefault ? 0 : 1;
    const db = b.isDefault ? 0 : 1;
    if (da !== db)
        return da - db;
    const na = (a.organisationNom ?? "").localeCompare(b.organisationNom ?? "", "fr");
    if (na !== 0)
        return na;
    return a.id.localeCompare(b.id);
}
/** Les casquettes dans l'ordre de priorité (copie triée, l'entrée n'est pas touchée). */
export function casquettesParPriorite(memberships) {
    return [...memberships].sort(comparerCasquettes);
}
/**
 * L'organisation ACTIVE par défaut : au login, et « maison » au retour
 * d'immersion. `undefined` sans aucune appartenance.
 */
export function membershipParDefaut(memberships) {
    return casquettesParPriorite(memberships)[0];
}
//# sourceMappingURL=casquettes.js.map